/* 🤖 this file was generated by svg-to-ts */
export const IconBigLightBriefumschlag: {
    name: 'big-light-briefumschlag';
    data: string;
} = {
    name: 'big-light-briefumschlag',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M118 25.5H10A4.51 4.51 0 0 0 5.5 30v68a4.51 4.51 0 0 0 4.5 4.5h108a4.51 4.51 0 0 0 4.5-4.5V30a4.51 4.51 0 0 0-4.5-4.5M92.77 69.23a2.5 2.5 0 0 0-3.54 3.54L114 97.5H14l24.77-24.73a2.5 2.5 0 0 0-3.54-3.54L10.5 94V34l48.9 48.9a6.52 6.52 0 0 0 9.2 0L117.5 34v60zM14 30.5h100L65.06 79.4a1.49 1.49 0 0 1-2.12 0z"/></svg>`,
};
